$(function () {
  'use strict';

  var $window = $(window);

  $('.slide-carousel').each(function (i, el) {
    var $el = $(el);
    var $regions = $el.children().not('.slide-carousel-main-title');
    var bulletCount = $regions.length;

    if ($regions.length === 2) {
      $regions.clone().appendTo($el);
      $regions = $el.children();
    } else if ($regions.length < 2) {
      return;
    }

    var activeClass = 'active';
    var prevClass = 'prev';
    var nextClass = 'next';
    var transitionClass = 'transition';
    var swipeNeighborClass = 'peeking-neighbor';
    var RegionBackgrounds = 'primary-grey0 primary-grey1 primary-grey2 primary-grey3 primary-grey4 primary-grey5 primary-grey6 primary-grey7 primary-grey8 primary-grey9';

    var actvateClasses = [
      activeClass,
      transitionClass
    ].join(' ');

    var allClasses = [
      activeClass,
      prevClass,
      nextClass,
      transitionClass
    ].join(' ');

    var count = $regions.length;
    var active = 0;

    //background Image
    var bgImage = $el.data('background-image');
    if (bgImage) {
      $el.css('background-image', 'url(' + bgImage + ')');
      $regions.removeClass(RegionBackgrounds);
    }

    // titles
    var $mainHeadingTitle = $el.children('.slide-carousel-main-title');
    var $titlesWrapper = $('<div>', {'class': 'slide-carousel-titles-wrapper'});
    $titlesWrapper.toggleClass('slide-carousel-has-heading', $mainHeadingTitle.length);

    var $titles = $('<ul>', {'class': 'slide-carousel-titles'}).appendTo($titlesWrapper);
    var titles = $el.data('carousel-titles').split(/\s*,\s*/g);
    titles.forEach(function (title) {
      $('<li>', {'class': 'slide-carousel-title'}).text(title).appendTo($titles);
    });
    var $titlesMobile = $('<div>', {'class': 'slide-carousel-titles-mobile'}).appendTo($titlesWrapper);

    // prev next buttons
    var $leftButton = $('<div>', {'class': 'slide-carousel-prev glyph-angle-left'});
    var $rightButton = $('<div>', {'class': 'slide-carousel-next glyph-angle-right'});
    var $buttons = $leftButton.add($rightButton);

    // indicator dots
    var $indexDots = $('<div>', {'class': 'slide-carousel-dots'});

    if (titles.join('') === '') {
      $regions.each(function (i, el) {
        $(el).css('padding-top', '6rem');
        $('<div>', {'class': 'slide-carousel-dot'}).appendTo($indexDots);
        return bulletCount > i + 1;
      });
      $indexDots.children().eq(0).addClass(activeClass);
    } else {
      titles.forEach(function () {
        $('<div>', {'class': 'slide-carousel-dot'}).appendTo($indexDots);
      });
      $indexDots.children().eq(0).addClass(activeClass);
    }

    var updatePrevNextPosition = function (info) {
      if (info.elHeight < info.windowHeight) {
        $buttons.css({
          position: '',
          top: ''
        });
      } else if (info.elTop + info.prevNextBuffer > info.middleOffsetTop) {
        $buttons.css({
          position: 'absolute',
          top: info.prevNextBuffer
        });
      } else if (info.relativeToElBottom < info.middleOffsetTop) {
        $buttons.css({
          position: 'absolute',
          top: info.elHeight - info.prevNextBuffer
        });
      } else {
        $buttons.css({
          position: 'fixed',
          top: info.middleOfViewport
        });
      }
    };

    var updateDotsPosition = function (info) {
      if (info.elHeight < info.windowHeight) {
        $indexDots.css({
          position: '',
          top: ''
        });
      } else if (info.elTop + info.dotsBufferDistance > info.scrollBottom) {
        $indexDots.css({
          position: 'absolute',
          top: info.dotsBufferDistance
        });
      } else if (info.elBottom < info.scrollBottom) {
        $indexDots.css({
          position: '',
          top: ''
        });
      } else {
        $indexDots.css({
          position: 'fixed',
          top: '100%'
        });
      }
    };

    var updateTitlePosition = function () {
      $titlesWrapper.toggleClass('overflowing', $titles.outerHeight() > $titles.children().outerHeight());
    };

    var scrollDotsIntoView = function (info, oldDotsTop) {
      var fromTopOfScreen = oldDotsTop - info.scrollTop;
      var newDotsTop = $indexDots.offset().top;
      var newScrollTop = Math.max(info.elTop, newDotsTop - fromTopOfScreen);

      if (info.elTop < info.scrollTop && newScrollTop < info.scrollTop) {
        $window.scrollTop(newScrollTop);
      }
    };

    var updateButtonPositions = function (oldDotsTop) {
      var info = {
        prevNextBuffer: 58,
        dotsBufferMin: 600
      };

      info.windowHeight = $window.height();
      info.elHeight = $el.height();
      info.scrollTop = $window.scrollTop();
      info.scrollBottom = info.scrollTop + info.windowHeight;
      info.middleOfViewport = Math.round(info.windowHeight / 2);
      info.middleOffsetTop = info.scrollTop + info.middleOfViewport;
      info.elTop = $el.offset().top;
      info.elBottom = info.elTop + info.elHeight;
      info.relativeToElBottom = info.elBottom - info.prevNextBuffer;
      info.dotsBufferDistance = Math.min(info.dotsBufferMin, info.windowHeight);

      updatePrevNextPosition(info);
      updateDotsPosition(info);
      updateTitlePosition();

      if ($.isNumeric(oldDotsTop)) {
        scrollDotsIntoView(info, oldDotsTop);
      }
    };

    var maxDistance = count / 2;
    var setPrevNext = function (compareIndex, hasNextClass) {
      return function (i, el) {
        if (i === compareIndex) {
          return;
        }

        var distanceToTheRight = (compareIndex - i + count) % count;
        var newClass = distanceToTheRight === maxDistance ? (hasNextClass ? prevClass : nextClass) :
          distanceToTheRight > maxDistance ? nextClass : prevClass;
        $(el).addClass(newClass);
      };
    };

    var directSelect = function (index) {
      var oldDotsTop = $indexDots.offset().top;
      var $newActive = $regions.eq(index);
      var hasNextClass = $newActive.hasClass(nextClass);

      $regions.removeClass(allClasses);
      $regions.filter('.' + swipeNeighborClass).addClass(transitionClass).removeClass(swipeNeighborClass);
      $regions.eq(active).addClass(transitionClass);
      $newActive.addClass(actvateClasses);
      $regions.each(setPrevNext(index, hasNextClass));
      $regions.css({left: '', visibility: ''});
      active = index;

      $indexDots.children().removeClass(activeClass).eq(index % bulletCount).addClass(activeClass);
      var $activeTitle = $titles.children().removeClass(activeClass).eq(index % bulletCount).addClass(activeClass);
      $titlesMobile.text($activeTitle.text());

      updateButtonPositions(oldDotsTop);
    };

    var rotate = function (compare) {
      var dir = compare > 0 ? 1 :
        compare < 0 ? -1 :
          0;
      var index = (count + active + dir) % count;
      directSelect(index);
    };

    // intialize
    $el.prepend($titlesWrapper);
    $el.append($buttons);
    $el.append($indexDots);
    directSelect(0);
    $el.addClass('slide-carousel-initialized');
    $el.removeClass('slide-carousel-uninitialized');

    $window.on('scroll resize', window.tscUtil.throttle(updateButtonPositions, 15));

    var isTransitioning = function () {
      return $regions.eq(active).position().left !== 0;
    };

    var autoTimerRef = 'autoRotateTimer';
    $el
      .attr('data-swipe', '') // register for swipe events
      .on('swipemove', function (e) {
        var dir = e.deltaX < 0 ? 1 : -1;
        var neighborIndex = (count + active + dir) % count;
        var neighborOffset = $el.width() * dir + e.deltaX;
        clearInterval($el.data(autoTimerRef));
        $regions
          .removeClass(transitionClass)
          .removeClass(swipeNeighborClass)
          .css({left: '', visibility: ''})
          .eq(active).css({
          left: e.deltaX + 'px'
        });

        $regions
          .eq(neighborIndex)
          .addClass(swipeNeighborClass)
          .css({
            visibility: 'visible',
            left: neighborOffset + 'px'
          });
      })
      .on('swipeend', function (e) {
        var swipeThreshold = 50;
        rotate(Math.trunc(e.deltaX * -1 / swipeThreshold));
      })
      .on('click', '.slide-carousel-prev', function () {
        if (!isTransitioning()) {
          rotate(-1);
          clearInterval($el.data(autoTimerRef));
        }
      })
      .on('click', '.slide-carousel-next', function () {
        if (!isTransitioning()) {
          rotate(1);
          clearInterval($el.data(autoTimerRef));
        }
      })
      .on('click', '.slide-carousel-dot, .slide-carousel-title', function () {
        var $this = $(this);
        if ($this.hasClass(activeClass)) {
          return;
        }

        if (!isTransitioning()) {
          directSelect($this.index());

          clearInterval($el.data(autoTimerRef));
        }
      });

    if ($el.hasClass('only-dots')) {
      $buttons.hide();
    }

    if ($el.hasClass('only-arrows')) {
      $indexDots.hide();
    }

    if ($el.hasClass('auto-rotate')) {
      $el.data(autoTimerRef, setInterval(function () {
        if (!isTransitioning()) {
          rotate(1);
        }
      }, 3500));
    }
  });
});
